
import { computed, defineComponent, PropType } from 'vue'
import { bookingLength, formatShortDate, fromMinutes, sourceDetail, sourceTitle } from '../helpers'
import { DayKey, HotWindow, HotWindowCandidate, HotWindowService } from '../types'
import HwIcon from './HwIcon.vue'

/** «Что предлагаем клиенту»: откуда → куда. Общий для карточки и модалки. */
export default defineComponent({
    name: 'HotWindowsMoveFlow',
    components: { HwIcon },
    props: {
        candidate: { type: Object as PropType<HotWindowCandidate>, required: true },
        window: { type: Object as PropType<HotWindow>, required: true },
        service: { type: Object as PropType<HotWindowService>, required: true },
        start: { type: Number, required: true },
        dayKey: { type: String as PropType<DayKey>, required: true },
        date: { type: String, required: true },
    },
    setup(props) {
        return {
            sourceTitle: computed(() => sourceTitle(props.candidate)),
            sourceDetail: computed(() => sourceDetail(props.candidate, props.window.master)),
            targetDay: computed(
                () => `${props.dayKey === 'today' ? 'Сегодня' : 'Завтра'}, ${formatShortDate(props.date)}`
            ),
            from: computed(() => fromMinutes(props.start)),
            to: computed(() => fromMinutes(props.start + bookingLength(props.candidate, props.service))),
        }
    },
})
